import React from 'react';

export const boldNameFormatter = value => {
  return <span style={{ fontWeight: 'bold' }}>{value}</span>;
};
